// src/components/ProductCard.tsx
import React from 'react';
import { motion } from 'framer-motion';
import { Edit, Trash2 } from 'lucide-react';
import { Button } from './ui/Button'; // Adjust path if needed
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle, AlertDialogTrigger } from './ui/alert-dialog'; // Adjust path if needed
import { Product } from '../types/Product'; // Import Product interface from new location
// import { Product, formatCurrency } from '../App'; // Import Product interface and formatCurrency from App.tsx

// Animation Variants
const productCardVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.3 } },
  exit: { opacity: 0, y: -20, transition: { duration: 0.2 } },
};

export const ProductCard = ({ product, onEdit, onDelete }: { product: Product; onEdit?: (id: string) => void; onDelete?: (id: string) => void; }) => {
  return (
    <motion.div
      variants={productCardVariants}
      initial="hidden"
      animate="visible"
      exit="exit"
      className="product-card"
    >
      <img src={product.imageUrl} alt={product.name} className="product-card-image" onError={(e) => { e.currentTarget.src = `https://placehold.co/150x150/E0E0E0/333333?text=${product.name.substring(0, 5)}` }} />
      <div className="product-card-content">
        <h3 className="product-card-title">{product.name}</h3>
        <p className="product-card-description">{product.description}</p>
        {/* <p className="product-card-price">{formatCurrency(product.price)}</p> */}
        {product.specifications && (
          <div className="product-card-specs">
            <h4 className="product-card-specs-title">Specifications:</h4>
            <ul className="product-card-specs-list">
              {Object.entries(product.specifications).map(([key, value]) => (
                <li key={key}>
                  {key}: {value}
                </li>
              ))}
            </ul>
          </div>
        )}
        {onEdit && onDelete && (
          <div className="product-card-actions">
            <Button variant="outline" size="icon" onClick={() => onEdit(product.id)}>
              <Edit className="icon" />
            </Button>
            <AlertDialog>
              <AlertDialogTrigger asChild>
                <Button variant="destructive" size="icon">
                  <Trash2 className="icon" />
                </Button>
              </AlertDialogTrigger>
              <AlertDialogContent>
                <AlertDialogHeader>
                  <AlertDialogTitle>Are you sure?</AlertDialogTitle>
                  <AlertDialogDescription>
                    This action cannot be undone. This will permanently delete {product.name}.
                  </AlertDialogDescription>
                </AlertDialogHeader>
                <AlertDialogFooter>
                  <AlertDialogCancel>Cancel</AlertDialogCancel>
                  <AlertDialogAction onClick={() => onDelete(product.id)}>Delete</AlertDialogAction>
                </AlertDialogFooter>
              </AlertDialogContent>
            </AlertDialog>
          </div>
        )}
      </div>
    </motion.div>
  );
};
